import { Wallet } from './../../../shared/components/wallet-history-expended/wallet-history-expended.component';
import { LoaderService } from './../../../core/services/loader.service';
import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import { SharedService } from '../../../shared/shared.service';
import {
  FormArray,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  createMaster,
  updateMaster,
} from '../../../store/Masters/masters.actions';
import { Helper } from '../../../core/helpers/helper';
import { Validations } from '../../../shared/constants/validations';
import { Umd } from '../../../shared/modals/common';
import { GetUmd, createUmd, updateUmd } from '../../../store/Umd/umd.actions';
import {
  McbButtons,
  UtilityType,
  valveRelaystatus,
} from '../../../shared/constants/enum';
import { Utilites } from '../../../store/Utilities/utilities.models';
import { UtilitesService } from '../../../core/services/utilities.services';
@Component({
  selector: 'app-rp-create-umd',
  templateUrl: './rp-create-umd.component.html',
  styleUrl: './rp-create-umd.component.scss',
  standalone: false,
})
export class RpCreateUMDComponent {
  // configData: any;
  createUMDForm!: UntypedFormGroup;
  submitted: boolean = false;
  @Input() umdData!: any;
  @Input() configData!: any;

  Umd_Validations = Validations.UmdCreatePage;
  currentUser: any;
  projectId: any;
  gatewayList: any[] = [];
  UtilityType = UtilityType;
  mcbPowerButtons = Object.values(McbButtons); // Convert enum to array of values
  valveRelaystatus = Object.values(valveRelaystatus); // Convert enum to array of values

  requiredfield: boolean = false;
  requiredSlabNamefield: boolean = false;
  requiredMcbMainPowerfield: boolean = false;
  waterTypeItems: any = [];
  gastyeItem: any[] = [];
  eletricityTypeItem: any[] = [];
  constructor(
    private router: Router,
    private store: Store,
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private sharedService: SharedService,
    private formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private utilitesService: UtilitesService

  ) {
     console.log(this.configData)
  }

  dismissModal(): void {
    this.modalService.hide();
  }

  isDisplay(utility: any) {
    const matchingUtility = this.configData?.utilities.find(
      (u: any) => u.id === utility
    );
    return matchingUtility?.name;
  }
  findInvalidControls(
    form: FormGroup | FormArray
  ): { controlName: string; status: string; errors: any }[] {
    const invalidControls: {
      controlName: string;
      status: string;
      errors: any;
    }[] = [];

    Object.keys(form.controls).forEach((name) => {
      const control = form.get(name);

      if (control instanceof FormGroup || control instanceof FormArray) {
        // recurse for nested controls
        invalidControls.push(...this.findInvalidControls(control));
      } else if (control && (control.invalid || control.pending)) {
        invalidControls.push({
          controlName: name,
          status: control.status, // "INVALID" | "PENDING"
          errors: control.errors,
        });
      }
    });

    return invalidControls;
  }
  CreateUMD(type: string): void {
    const invalidControls = this.findInvalidControls(this.createUMDForm);
    console.log('Invalid controls:', invalidControls);

    console.log('valid:', this.createUMDForm.valid);
    console.log(this.createUMDForm.get('supplierId')?.value);
    const supplierIdValue = this.createUMDForm.get('supplierId')?.value
    this.submitted = true;
    if (this.createUMDForm.valid) {
      this.loaderService.setLoading(true);
      let request = {
        projectId: this.createUMDForm.get('projectId')?.value,
        utilityMasterId: this.createUMDForm.get('utilityMasterId')?.value,
        macAddress: this.createUMDForm.get('macAddress')?.value,
        status: this.createUMDForm.get('status')?.value,
        meterSerialNo: this.createUMDForm.get('meterSerialNo')?.value,
        mcbMainPower: this.createUMDForm.get('mcbMainPower')?.value,
        supplierId: supplierIdValue && supplierIdValue.toString().trim() !== ''
          ? supplierIdValue
          : '00000000-0000-0000-0000-000000000000',
        gatewayInformationId: this.createUMDForm.get(
          'isWiredCommunicationDevice'
        )?.value
          ? this.selectedGateway.id
          : null,
        gatewayName: this.createUMDForm.get('isWiredCommunicationDevice')?.value
          ? this.selectedGateway.serialNumber
          : null,
        isWiredCommunicationDevice: this.createUMDForm.get(
          'isWiredCommunicationDevice'
        )?.value,
        deviceId: this.createUMDForm.get('isWiredCommunicationDevice')?.value
          ? this.createUMDForm.get('deviceId')?.value
          : '',
      };
      // Process form data (send to backend, etc.)
      console.log(request);
      if (type == 'Create') {
        this.store.dispatch(createUmd({ UmdData: request }));
      } else if (type == 'Update') {
        console.log('sddaj');
        console.log(this.createUMDForm.get('valveRelaystatus')?.value);
        let request = {
          projectId: this.createUMDForm.get('projectId')?.value,
          utilityMasterId: this.createUMDForm.get('utilityMasterId')?.value,
          macAddress: this.createUMDForm.get('macAddress')?.value,
          status: this.createUMDForm.get('status')?.value,
          meterSerialNo: this.createUMDForm.get('meterSerialNo')?.value,
          mcbMainPower: this.createUMDForm.get('mcbMainPower')?.value,
        //  supplierId: this.createUMDForm.get('supplierId')?.value,
          supplierId: supplierIdValue && supplierIdValue.toString().trim() !== ''
            ? supplierIdValue
            : '00000000-0000-0000-0000-000000000000',
          gatewayInformationId: this.createUMDForm.get(
            'isWiredCommunicationDevice'
          )?.value
            ? this.selectedGateway.id
            : null,
          gatewayName: this.createUMDForm.get('isWiredCommunicationDevice')
            ?.value
            ? this.selectedGateway.serialNumber
            : null,
          isWiredCommunicationDevice: this.createUMDForm.get(
            'isWiredCommunicationDevice'
          )?.value,
          valveRelaystatus:
            this.createUMDForm.get('valveRelaystatus')?.value == 'On'
              ? true
              : false,
          deviceId: this.createUMDForm.get('isWiredCommunicationDevice')?.value
            ? this.createUMDForm.get('deviceId')?.value
            : '',
        };

        console.log(request);
        this.store.dispatch(
          updateUmd({
            UmdData: request,
            id: this.umdData.id ? this.umdData.id : '',
          })
        );
      }
      this.modalService.hide();
    }
  }
  getsata(event: any) {
    console.log(event);
  }
  get f() {
    return this.createUMDForm.controls;
  }
  regex = /^[A-Z0-9]*$/;
  onlynumber = /^\d+$/;

  /* Wired - Min & max 7 Serial num & Macaddress
Wireless - Min 7 & Max 16 for Serial num & Macaddress
  */
  Macregex = /^[0-9A-F]+$/;
  //  Macregex = /^(?=.*[0-9])(?=.*[A-F])[0-9A-F]+$/;
  IsWiredMacregex = /^[0-9]+$/;
  SerialIswired = /^[A-Z0-9]+$/;

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.projectId = this.currentUser?.project.id;
    this.gateWayList();
    this.createUMDForm = this.formBuilder.group({
      projectId: this.projectId,
      utilityMasterId: [, Validators.required],
      macAddress: [
        '',
        [
          Validators.required,
          Validators.pattern(this.Macregex),
          Validators.maxLength(16),
          Validators.minLength(16),
        ],
      ],
      meterSerialNo: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex),
          Validators.maxLength(16),
          Validators.minLength(7),
        ],
      ],
      status: [, Validators.required],
      mcbMainPower: [,],
      gatewayName: [],
      deviceId: [],
      valveRelaystatus: [],
      isWiredCommunicationDevice: [false],
      supplierId: [null, Validators.required],
    });

    this.createUMDForm
      ?.get('utilityMasterId')
      ?.valueChanges.subscribe((value) => {
        console.log(value);
        this.handleUtilityChange(value);
      });

    if (this.umdData?.id != undefined) {
      this.patchForm();
    }
    // this.getAllConfigData();
  }
  gateWayList() {
    this.utilitesService.getGeatewayList(this.projectId).subscribe({
      next: (response) => {
        console.log(response);
        if (response && response.statusCode === 200) {
          this.gatewayList = response.data;
          /*  response.data.forEach((item: any) => {
             this.getwayList.push({ id: item.id, name: item.serialNumber })
           }) */
          console.log(this.gatewayList);
        }
      },
      error: (err) => { },
    });
  }
  isrequred: boolean = false;
  handleUtilityChange(value: any): void {
    if (value) {
      this.requiredfield = false;
      this.requiredSlabNamefield = false;
      this.requiredMcbMainPowerfield = false;
      if (
        this.isDisplay(value) === UtilityType.ELECTRICITY ||
        this.isDisplay(value) === UtilityType.TriSource
      ) {
        this.requiredfield = true;
        this.requiredMcbMainPowerfield = true;
        this.createUMDForm
          .get('mcbMainPower')
          ?.setValidators([Validators.required]);
      } else {
        this.createUMDForm.get('mcbMainPower')?.clearValidators();
        this.createUMDForm.get('mcbMainPower')?.updateValueAndValidity();
      }

      if (this.isDisplay(value) === UtilityType.WATER) {
        this.requiredSlabNamefield = true;
        this.createUMDForm
          .get('supplierId')
          ?.setValidators([Validators.required]);
        this.isrequred = true;
      } else {
        this.isrequred = false;
        this.createUMDForm.get('supplierId')?.clearValidators();
        this.createUMDForm.get('supplierId')?.updateValueAndValidity();
      }
      //  this.createUMDForm.get('supplierId')?.updateValueAndValidity();
      //  this.createUMDForm.get('mcbMainPower')?.updateValueAndValidity(); // Ensure the state is updated
    }
  }
  iswirdeCommunication: boolean = false;

  onCheckboxChange(event: any) {
    // console.log(event.target.checked);
    this.iswirdeCommunication = event.target.checked;
    console.log(this.iswirdeCommunication);

    if (event.target.checked) {
      // When checkbox is checked, add the required validators
      this.f['gatewayName'].setValidators([Validators.required]);
      this.f['gatewayName'].updateValueAndValidity(); // Ensure validity is updated
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.IsWiredMacregex),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.SerialIswired),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);
      this.f['deviceId'].setValidators([
        Validators.required,
        Validators.pattern(this.onlynumber),
      ]);
      this.f['macAddress'].updateValueAndValidity();
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['deviceId'].updateValueAndValidity(); // Ensure validity is updated
    } else {
      // When checkbox is unchecked, clear the validators and update validity
      //console.log(this.iswirdeCommunication);

      this.f['gatewayName'].clearValidators(); // Remove validators
      // Update validity without triggering events
      this.f['deviceId'].clearValidators(); // Remove validators
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.Macregex),
        Validators.maxLength(16),
        Validators.minLength(16),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.regex),
        Validators.maxLength(16),
        Validators.minLength(7),
      ]);
      this.f['macAddress'].updateValueAndValidity();
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['gatewayName'].updateValueAndValidity({});
      this.f['deviceId'].updateValueAndValidity({}); // Update validity without triggering events
    }
  }

  selectedGateway: any;
  selectionChange(event: any) {
    console.log(event);
    this.selectedGateway = event;
  }
  patchForm(): void {
    console.log(this.umdData)
    console.log(this.configData)
    // this.sharedService.getAllConfigData(true).subscribe((data) => {
    //   if (
    //     data.statusCode == 200 &&
    //     data.message == 'Config data retrieved successfully.'
    //   ) {
    // this.configData = data;

    //console.log(this.umdData.valveRelayStatus)
    this.iswirdeCommunication = this.umdData?.isWiredCommunicationDevice
      ? true
      : false;
    if (this.iswirdeCommunication) {
      this.f['gatewayName'].setValidators([Validators.required]);
      this.f['gatewayName'].updateValueAndValidity;
      this.f['deviceId'].setValidators([
        Validators.required,
        Validators.pattern(this.onlynumber),
      ]);
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.IsWiredMacregex),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.SerialIswired),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);

      this.f['macAddress'].updateValueAndValidity();
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['deviceId'].updateValueAndValidity;
    } else {
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.Macregex),
        Validators.maxLength(16),
        Validators.minLength(16),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.regex),
        Validators.maxLength(16),
        Validators.minLength(7),
      ]);
      this.f['macAddress'].updateValueAndValidity();
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['gatewayName'].clearValidators();
      this.f['gatewayName'].updateValueAndValidity;
      this.f['deviceId'].clearValidators();
      this.f['deviceId'].updateValueAndValidity;
      console.log('this.configData?.suppliers');
    }
    this.selectedGateway = {
      id: this.umdData?.gatewayInformationId ?? null,
      serialNumber: this.umdData?.gatewayName ?? null,
    };

    this.selectedutlity = this.umdData?.utility;
    if (this.selectedutlity?.name) {
      this.waterTypeItems = this.configData?.suppliers?.filter((item: any) => {
        return (
          item?.master?.name?.toLowerCase() ===
          this.selectedutlity.name.toLowerCase()
        );
      }) ?? [];
    }

    if (this.umdData?.utility?.id) {

      this.createUMDForm.controls['utilityMasterId'].disable();

      this.createUMDForm.controls['macAddress'].disable();

      this.createUMDForm.controls['meterSerialNo'].disable();

      this.createUMDForm.controls['isWiredCommunicationDevice'].disable();

      // this.createUMDForm.controls['gatewayName'].disable();

      this.createUMDForm.controls['deviceId'].disable();
      console.log(this.umdData);
      this.selectedutlity = this.umdData?.utility;
      /*    6d5613c0 - 9d09 - 45fe - b430 -08dcf811f2e9
         e63910ba - f200 - 4ba6 - 7172 -08ddd116d546 */
      this.createUMDForm.patchValue({
        utilityMasterId: this.umdData?.utility?.id
          ? this.umdData?.utility?.id
          : '',
        macAddress: this.umdData?.macAddress ? this.umdData?.macAddress : '',
        meterSerialNo: this.umdData?.meterSerialNo ?? '',
        status: this.umdData?.status ? this.umdData?.status : '',
        mcbMainPower: this.umdData?.mcbMainPower ?? '',
        supplierId: this.umdData?.supplierId ?? null,
        gatewayName: this.umdData?.gatewayInformationId ?? null,
        isWiredCommunicationDevice:
          this.umdData?.isWiredCommunicationDevice ?? false,
        valveRelaystatus:
          this.umdData.valveRelayStatus === 'ON' ||
            this.umdData.valveRelayStatus === 'Yes'
            ? valveRelaystatus.On
            : valveRelaystatus.Off,
        deviceId: this.umdData.deviceId,
      });
      /*  if (this.umdData.isWiredCommunicationDevice) {
        this.f['macAddress'].setValidators(
          Validators.pattern(this.IsWiredMacregex)
        );
        this.f['macAddress'].updateValueAndValidity();
      } else {
        this.f['macAddress'].setValidators(Validators.pattern(this.Macregex));
        this.f['macAddress'].updateValueAndValidity();
      } */
      this.cdr.detectChanges();
    }
    //
    //   }
    //   console.log('Types', this.configData.data.types);
    // });
  }

  selectedutlity: any;
  changeUtility(event: any) {
    console.log(event);
    this.selectedutlity = event;
    this.waterTypeItems = [];
    this.createUMDForm.controls['supplierId'].setValue('');
    console.log(this.configData?.suppliers)

    this.createUMDForm.controls['isWiredCommunicationDevice'].setValue(false);
    this.waterTypeItems = this.configData?.suppliers.filter((item: any) => {
      return item.master.name.toLowerCase() === event.name.toLowerCase();
    });
    console.log(this.waterTypeItems)
  }
    isClearable(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed === '00000000-0000-0000-0000-000000000000') {
        return false;
      }
      return trimmed !== '' && trimmed !== '-';
    }
    if (typeof value === 'number') {
      return value !== 0;
    }
    if (typeof value === 'object') {
      const raw =
        (value.name ?? value.label ?? value.value ?? value.id ?? '')
          .toString()
          .trim();
      return raw !== '' && raw !== '-';
    }
    return true;
  }
}
